<div class="placeholder-tile ">
    <div *ngIf="vehicleCount === 1">
            <span class="dt-icon dt-icon-myfavorite-no-1"></span>
    </div>
    <div *ngIf="vehicleCount === 2">
        <span class="dt-icon dt-icon-myfavorite-no-2"></span>
    </div>
   
</div>